"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchRequests = void 0;
const Paths_1 = require("../../Paths");
const Utils_1 = require("../../Utils");
const ProfileRequestUtils_1 = require("./utils/ProfileRequestUtils");
class SwitchRequests {
    constructor(session, profileId) {
        this.session = session;
        this.profileId = profileId;
    }
    create(type, downstream, multiway, enabled, loadUUID) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiSwitch = {
                device_type: type,
                load_id: loadUUID,
                downstream,
                enabled,
                load_multi_way: multiway,
                profile_id: this.profileId,
            };
            const loadRequest = {
                method: Paths_1.Methods.POST,
                body: apiSwitch,
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, loadRequest);
            const endpoint = (0, ProfileRequestUtils_1.getExternalEndpoint)(this.session, loadRequest, Paths_1.Constants.SWITCH);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    remove(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const loadRequest = {
                method: Paths_1.Methods.DELETE,
                body: {
                    uuid,
                },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, loadRequest);
            const endpoint = (0, ProfileRequestUtils_1.getExternalEndpoint)(this.session, loadRequest, Paths_1.Constants.SWITCH);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    update(uuid, changes) {
        return __awaiter(this, void 0, void 0, function* () {
            const switchRequest = {
                method: Paths_1.Methods.PUT,
                body: Object.assign(Object.assign({}, changes), { uuid }),
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, switchRequest);
            const endpoint = (0, ProfileRequestUtils_1.getExternalEndpoint)(this.session, switchRequest, Paths_1.Constants.SWITCH);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    get(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const switchRequest = {
                method: Paths_1.Methods.GET,
                body: {
                    uuid,
                },
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, switchRequest);
            const endpoint = (0, ProfileRequestUtils_1.getExternalEndpoint)(this.session, switchRequest, Paths_1.Constants.SWITCH);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    genericSwitchRequest(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            const endpoint = (0, ProfileRequestUtils_1.getEndpoint)(this.session, options, this.profileId, Paths_1.Constants.SWITCH);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
}
exports.SwitchRequests = SwitchRequests;
//# sourceMappingURL=SwitchRequests.js.map